class LambdaCountdownSimple
{
	static initSimpleCountdowns()
	{
		document.querySelectorAll('[data-countdown-simple="1"]').forEach((el) => this.setupElements(el));
	}

	static setupElements(el)
	{
		let countdown = LambdaCountdown.fromElement(el);
		countdown.setTickCallback((data) => this.countdownUpdate(el, data));

		this.setupMarkup(el, countdown);
	}

	static setupMarkup(el, countdown)
	{
		let html = `
			<div class="flex items-center">
		`;

		if(countdown.hasYears()) {
			html += this.newUnitElement("years");
			html += this.separator();
		}

		if(countdown.hasMonths()) {
			html += this.newUnitElement("months");
			html += this.separator();
		}

		if(countdown.hasWeeks()) {
			html += this.newUnitElement("weeks");
			html += this.separator();
		}

		if(countdown.hasDays()) {
			html += this.newUnitElement("days");
			html += this.separator();
		}

		if(countdown.hasHours()) {
			html += this.newUnitElement("hours");
			html += this.separator();
		}

		html += this.newUnitElement("minutes");
		html += this.separator();

		html += this.newUnitElement("seconds");

		html += `</div>`;

		el.innerHTML = html;
	}

	static newUnitElement(type)
	{
		return `
			<div data-countdown-domtype="${type}">0</div>
		`;
	}

	static separator()
	{
		return `<div>:</div>`;
	}

	static countdownUpdate(el, data)
	{
		var yearDom = el.querySelector('[data-countdown-domtype="years"]');
		var monthDom = el.querySelector('[data-countdown-domtype="months"]');
		var weekDom = el.querySelector('[data-countdown-domtype="weeks"]');
		var dayDom = el.querySelector('[data-countdown-domtype="days"]');
		var hourDom = el.querySelector('[data-countdown-domtype="hours"]');
		var minuteDom = el.querySelector('[data-countdown-domtype="minutes"]');
		var secondDom = el.querySelector('[data-countdown-domtype="seconds"]');

		if(yearDom) {
			yearDom.innerText = String(data.Years).padStart(2, '0');
		}

		if(monthDom) {
			monthDom.innerText = String(data.Months).padStart(2, '0');
		}

		if(weekDom) {
			weekDom.innerText = String(data.Weeks).padStart(2, '0');
		}

		if(dayDom) {
			dayDom.innerText = String(data.Days).padStart(2, '0');
		}

		if(hourDom) {
			hourDom.innerText = String(data.Hours).padStart(2, '0');
		}

		if(minuteDom) {
			minuteDom.innerText = String(data.Minutes).padStart(2, '0');
		}

		if(secondDom) {
			secondDom.innerText = String(data.Seconds).padStart(2, '0');
		}
	}

}

export default LambdaCountdownSimple;
